import {QueueItemType} from "../../types";
import MediaCenterBox from "../../components/ImageCenter/MediaCenterBox";

export interface QueueItemPintrestProps {
    data: QueueItemType;
}

export default function QueueItemPintrest({data}: QueueItemPintrestProps) {
    const image = <img className="max-h-[1000px]" src={data?.metadata?.url} alt={data?.metadata?.name}
                       width={data?.metadata?.width || ''}
                       height={data?.metadata?.height || '100%'}/>;

    return (
        <MediaCenterBox className="!bg-dark-black rounded-none !overflow-hidden  max-w-[100%] relative">
            {data?.metadata?.description && (<span className="absolute bottom-0 bg-semi-transparent p-1 rounded m-1">{data.metadata.description}</span>)}
            {
                data?.metadata?.referringUrl
                    ?
                    (
                        <a href={data?.metadata?.referringUrl} target="_blank" rel="noreferrer">
                            {image}
                        </a>
                    )
                    :
                    image
            }
        </MediaCenterBox>
    );
}